module.exports = __webpack_public_path__ + "img/icon_map_13_on_001.e64813fa.png";